(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-us-form"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const contactPopup = document.getElementById('contact-us-popup');
  const openPopupButton = document.querySelector('.open-contact-popup');
  const closePopupButton = document.querySelector('.close-popup');

  if (openPopupButton && contactPopup) {
    openPopupButton.addEventListener('click', () => {
      contactPopup.classList.add('active');
      document.body.insertAdjacentHTML('beforeend', '<div class="popup-overlay active"></div>');
    });

    closePopupButton.addEventListener('click', () => {
      contactPopup.classList.remove('active');
      const overlay = document.querySelector('.popup-overlay');
      if (overlay) overlay.remove();
    });

    document.body.addEventListener('click', (event) => {
      if (event.target.classList.contains('popup-overlay')) {
        contactPopup.classList.remove('active');
        const overlay = document.querySelector('.popup-overlay');
        if (overlay) overlay.remove();
      }
    });
  }
});
document.addEventListener('DOMContentLoaded', () => {
  const contactForm = document.getElementById('contact-us-form');
  const notification = document.getElementById('form-notification');

  if (contactForm) {
    contactForm.addEventListener('submit', (event) => {
      event.preventDefault(); // Prevent default form submission

      // Simulate form submission for this example (replace with AJAX if needed)
      setTimeout(() => {
        // Show notification
        notification.classList.remove('hidden');

        // Hide notification after 3 seconds
        setTimeout(() => {
          notification.classList.add('hidden');
          document.getElementById('contact-us-popup').classList.remove('active');
          const overlay = document.querySelector('.popup-overlay');
          if (overlay) overlay.remove();
        }, 3000);

        // Optionally, reset the form fields
        contactForm.reset();
      }, 500);
    });
  }
});


  } catch(e) { console.error(e); }
})();
})();
